import { axiosClientAdmin } from "@/lib/auth";
import { UseMutationOptionsAny } from "../query";
import { SpeakerDto } from "@/lib/integrationTypes/integrationTypes";

export type CreateSpeakerInput = {
  name: string;
  componentGroupId: string;
  relatedComponentGroups?: string[];
  enabled?: boolean;
};

export type UpdateSpeakerInput = {
  id: string;
  name: string;
  componentGroupId: string;
  relatedComponentGroups?: string[];
  enabled?: boolean;
};

export type DeleteSpeakerInput = {
  id: string;
};

export type SpeakerCrudded = {
  success: boolean;
  message: string;
  code: number;
  errors: string[];
  speaker: SpeakerDto;
};

// Create speaker component
export const createSpeaker = async (input: CreateSpeakerInput): Promise<SpeakerCrudded> => {
  const { data } = await axiosClientAdmin.post<SpeakerCrudded>("/Integration/Speaker", input);
  return data;
};

export const CreateSpeakerMut = () => {
  return {
    mutationFn: createSpeaker,
    mutationKey: ["createSpeaker"],
  } satisfies UseMutationOptionsAny;
};

// Update speaker component
export const updateSpeaker = async (input: UpdateSpeakerInput): Promise<SpeakerCrudded> => {
  const { data } = await axiosClientAdmin.put<SpeakerCrudded>(`/Integration/Speaker/${input.id}`, input);
  return data;
};

export const UpdateSpeakerMut = () => {
  return {
    mutationFn: updateSpeaker,
    mutationKey: ["updateSpeaker"],
  } satisfies UseMutationOptionsAny;
};

// Delete speaker component
export const deleteSpeaker = async (input: DeleteSpeakerInput): Promise<SpeakerCrudded> => {
  const { data } = await axiosClientAdmin.delete<SpeakerCrudded>(`/Integration/Speaker/${input.id}`);
  return data;
};

export const DeleteSpeakerMut = () => {
  return {
    mutationFn: deleteSpeaker,
    mutationKey: ["deleteSpeaker"],
  } satisfies UseMutationOptionsAny;
};

// Fetch speaker by ID
export const fetchSpeaker = async (id: string): Promise<SpeakerCrudded> => {
  const { data } = await axiosClientAdmin.get<SpeakerCrudded>(`/Integration/Speaker/${id}`);
  return data;
};

export const FetchSpeakerQuery = (id: string) => {
  return {
    queryKey: ['speaker', id],
    queryFn: () => fetchSpeaker(id),
    enabled: !!id,
  };
};